const { REACT_APP_LOGS_ENABLED = "false" } = process.env;

const logger = {
  info: (...messages) => {
    if (REACT_APP_LOGS_ENABLED === "true") console.log("[INFO]:", ...messages);
  },
  warn: (...messages) => {
    if (REACT_APP_LOGS_ENABLED === "true") console.warn("[WARN]:", ...messages);
  },
  error: (...messages) => {
    if (REACT_APP_LOGS_ENABLED === "true") console.error("[ERROR]:", ...messages);
  },
  debug: (...messages) => {
    if (REACT_APP_LOGS_ENABLED === "true") console.debug("[DEBUG]:", ...messages);
  },
};

export default logger;
